import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';

import { AppComponent } from './app.component';
import { NgxMasonryComponent } from './ngx-masonry/ngx-masonry.component';
import { NgxMasonryDirective } from './ngx-masonry/ngx-masonry.directive';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-bootstrap/carousel';
// import { CarouselComponent } from 'ngx-bootstrap/carousel/carousel.component.d';

@NgModule({
  declarations: [
    AppComponent,
    NgxMasonryComponent,
    NgxMasonryDirective,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CarouselModule.forRoot()
  ],
  providers: [],
  bootstrap: [AppComponent],
  // schemas: [
  //   CUSTOM_ELEMENTS_SCHEMA,
  //   NO_ERRORS_SCHEMA
  // ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts